






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AttachmentTypeDialog extends Vue {
  @Prop({ default: false }) show!: boolean;

  @Prop({ default: () => [] }) typeOptions!: Array<{ code: string, name: string }>;

  selectedType: string | null = null;

  confirmType() {
    this.$emit('select', this.selectedType);
    this.close();
  }

  close() {
    this.$emit('update:show', false);
    this.selectedType = null;
  }
}
